module.exports = __webpack_public_path__ + "img/catapult_small.eb3141a9.png";